<div [id]="'loader-spinner-'+loader.from"
    class="common-spinner__window-loader">
    <p-progressSpinner styleClass="common-spinner__progress-container-white-XL"
      ariaLabel="loading"></p-progressSpinner>
</div>
